<div class="header shimmer"></div>

<div class="status shimmer"></div>

<div class="section">
  <div *ngFor="let i of 3 | fill" class="section-item">
    <div class="item-header shimmer"></div>
    <div class="item-content shimmer"></div>
  </div>
</div>

<div class="section-header shimmer"></div>

<div class="section">
  <div *ngFor="let i of 6 | fill" class="section-item">
    <div class="item-header shimmer"></div>
    <div class="item-content shimmer"></div>
  </div>
</div>
